export default "__VITE_ASSET__Co5TNaY0__"